import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "../../utils/page-title";

const WIZARD_STEP_TITLES: Record<string, string> = {
  overview: "Your Human Design Report · Overview",
  "type-strategy": "Your Human Design Report · Type and Strategy",
  authority: "Your Human Design Report · Authority",
  "profile-purpose": "Your Human Design Report · Profile and Purpose",
  "centers-next-steps": "Your Human Design Report · Centers",
  "incarnation-cross": "Your Human Design Report · Incarnation Cross",
};

export const Route = createFileRoute("/wizard/$stepId")({
  head: ({ params }) => ({
    ...pageHead(WIZARD_STEP_TITLES[params.stepId] ?? "Your Human Design Report", {
      canonicalPath: `/wizard/${params.stepId}`,
      robots: "noindex, nofollow",
    }),
  }),
});
